module.exports = __webpack_public_path__ + "static/the-geography-of-bliss-247ba98ed2fc237e3610249694c218cf.jpg";